"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectStatus = void 0;
var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["NOT_STARTED"] = "NOT_STARTED";
    ProjectStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ProjectStatus["LATE"] = "LATE";
    ProjectStatus["COMPLETED"] = "COMPLETED";
    ProjectStatus["AWAITING_BUYER_RESPONSE"] = "AWAITING_BUYER_RESPONSE";
    ProjectStatus["ARCHIVED"] = "ARCHIVED";
    ProjectStatus["ALL"] = "ALL";
})(ProjectStatus = exports.ProjectStatus || (exports.ProjectStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdC1zdGF0dXMtZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wcm9qZWN0L3R5cGVzL3Byb2plY3Qtc3RhdHVzLWVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7R0FNRzs7O0FBRUgsSUFBWSxhQVFYO0FBUkQsV0FBWSxhQUFhO0lBQ3ZCLDRDQUEyQixDQUFBO0lBQzNCLDRDQUEyQixDQUFBO0lBQzNCLDhCQUFhLENBQUE7SUFDYix3Q0FBdUIsQ0FBQTtJQUN2QixvRUFBbUQsQ0FBQTtJQUNuRCxzQ0FBcUIsQ0FBQTtJQUNyQiw0QkFBVyxDQUFBO0FBQ2IsQ0FBQyxFQVJXLGFBQWEsR0FBYixxQkFBYSxLQUFiLHFCQUFhLFFBUXhCIn0=